export default {
    title: `Statistics for this month on my accounts`,
    legend: `Averages based on the past month, compared to the previous one.`,
    snaEmpty: `You haven’t added any social media account yet`,
    seePerformance: `See the performance of all my posts`,
};
